// extracted by mini-css-extract-plugin
module.exports = {"marqueeWrapper":"Examples_marqueeWrapper__PYKKX","marqueeTrack":"Examples_marqueeTrack___qtuv","marquee":"Examples_marquee__0FoeZ","card":"Examples_card__ITKdj"};